import axios from 'axios';

/**
 * ContactForm Module
 * to handle the contact-form
 */
export default class {
  /**
   * constructor
   *   initializes
   *   eventListeners
   *   for all forms
   */
  constructor() {
    this.formElements = document.querySelectorAll('form[data-submit-form]');

    if (this.formElements) {
      this.submitResponseContainerSelector = '[data-submit-form-response-container]';
      this.submitResponseContainerActiveClass = 'contact-form__response-container--show';

      this.formElements.forEach((form) => {
        form.addEventListener('submit', (event) => this.submitHandler(event));
      });
    }
  }

  /**
   * @function submitHandler
   * @desc handles the api post
   *       and form reset
   * @param {submit} event
   */
  submitHandler(event) {
    event.preventDefault();

    const form = event.target;
    const responseContainer = form.querySelector(this.submitResponseContainerSelector);
    const responseSnippetClass = responseContainer.dataset.submitFormResponseSnippetSelector;
    const responseSnippet = form.querySelector(responseSnippetClass);
    const method = form.getAttribute('method');
    const url = form.getAttribute('action');
    const data = new FormData(form);

    responseSnippet.innerText = responseContainer.dataset.submitFormResponseMessageProgress;
    responseContainer.classList.add(this.submitResponseContainerActiveClass);

    axios({
      method,
      url,
      data,
      headers: { 'Content-Type': 'multipart/form-data' },
    })
      .then(() => {
        responseSnippet.innerText = responseContainer.dataset.submitFormResponseMessageSuccess;
        form.reset();
      })
      .catch((error) => {
        responseSnippet.innerText = responseContainer.dataset.submitFormResponseMessageFailure;
      })
      .finally(() => {
        form.querySelector('[type=submit]').disabled = false; // eslint-disable-line no-param-reassign
      });
  }
}
